import { combineReducers } from "redux";
import authReducer from "./authReducer";
import homeReducer from "./homeReducer";
import userProfileReducer from "./userProfileReducer";
import needsReducer from "./needsReducer";
import cardsReducer from "./cardsReducer";
const rootReducer = combineReducers({
  authReducer,
  homeReducer,
  userProfileReducer,
  needsReducer,
  cardsReducer,
});

export default rootReducer;
